export const SlowLocalOrderStatuses = {
  Initiated: 'initiated',
  Pending: 'pending',
};
